var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderedList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75195 4.92383L4.75195 3.92383V7.59049M4.75195 7.59049H3.75195M4.75195 7.59049H5.41862M9.41861 10.2572H8.35611C7.86895 10.2572 7.59743 9.71442 7.85581 9.32874C7.88764 9.28122 7.9327 9.24458 7.98032 9.21289L9.18022 8.41446C9.22784 8.38278 9.27275 8.34598 9.30525 8.29892C9.60217 7.86905 9.29948 7.25716 8.75367 7.25716H7.75195M11.752 10.5905H12.7162C13.5392 10.5905 13.6852 11.8489 12.9253 12.0609C12.8885 12.0712 12.85 12.0753 12.8118 12.0766L12.4186 12.0905L12.8118 12.1043C12.85 12.1057 12.8885 12.1098 12.9253 12.1201C13.6852 12.3321 13.5392 13.5905 12.7162 13.5905H11.752",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderedList);
export default __webpack_public_path__ + "static/media/ordered-list.b9fb3c832b222231058932a38d986963.svg";
export { ForwardRef as ReactComponent };